import { SeasonalEventRegion } from "reedy-data/models";
import type { SeasonalEvent } from "integrations/firebase/collections/seasonalEvents";

export const getNextOccurrenceStart = (
  event: Pick<SeasonalEvent, "occurrences">,
  today: string,
): string | undefined => {
  const upcoming = event.occurrences
    .filter((occurrence) => occurrence.end >= today)
    .sort((a, b) => a.start.localeCompare(b.start));

  return upcoming[0]?.start;
};

export const getRegionLabel = (
  region: SeasonalEventRegion,
  t: (key: string) => string,
): string => {
  switch (region) {
    case SeasonalEventRegion.US:
      return t("components:regionBadge.us");
    case SeasonalEventRegion.UK:
      return t("components:regionBadge.uk");
    case SeasonalEventRegion.DE:
      return t("components:regionBadge.de");
    case SeasonalEventRegion.AUS:
      return t("components:regionBadge.aus");
    case SeasonalEventRegion.INTERNATIONAL:
      return t("components:regionBadge.international");
    default:
      return String(region).toUpperCase();
  }
};
